export interface ICompanyExportDto {
    name: string;
    street: string;
    additionToAddress: string;
    zip: string;
    city: string;
    country: string;
    legalform: string;
    email: string;
    phone: string;
    UID: string;
    taxDomicile: string | null;
    assignee: string;
    clerk: string;
    GICSCode: string;
    firstName?: string;
    lastName?: string;
    workFlow?: string;
}
